import type { Browser } from '@modules/browser';

// editor constants.
export const editorVersion = 'web_editor_v1';
export const bgColor = 0x282828;
export const viewfinderLineWidth = 1;
export const defaultCanvasHeight = 500;
export const zoomStep = 0.01;
export const positionSpringConstant = 1 / 12;
export const zoomSpringConstant = 1 / 12;
export const blurrerWidth = 500;
export const blurrerAlpha = 0.4;
export const snaplineSensitivityPx = 5;
export const snaplineAlpha = {
  max: 1,
  min: 0.0001,
  step: 0.005,
  spring: 15,
};
export const suggestions = {
  pixelEdgeDepth: 1,
  edgeSignificance: 0.5,
  colorEqualThreshold: 3,
  camouflageThreshold: 1,
};

export const lowQualityImageGenerationRateMs = 30;
export const highQualityImageGenerationRateMs: Record<Browser, number> = {
  chrome: 300,
  safari: 300,
  firefox: 500,
  edge: 300,
  opera: 600,
};
export const highQualityLoopLength = 50;
export const highQualityDelayThreshold = 250;
/** Controls the quality of the high quality image. */
export const highQualityTextureResolution: Record<Browser, number> = {
  chrome: 8,
  safari: 4,
  firefox: 4,
  edge: 4,
  opera: 4,
};

export const fadeSpeed = 0.05;
export const canDragThreshold = 0.05;
export const dragToRepositionEntryThreshold = 25;
